// extracted by mini-css-extract-plugin
export var standaloneTable = "_n-0";
export var standaloneTableWithBodyFill = "_n-1";
export var withExtraHeader = "_n-2";